import { CheckNotes, InspectionCase } from '../../inspection-cases';
import { PumpRoomInstallationMain } from './pump-room-installation-main.dto';
import { Pump } from './pump.dto';
import { WaterReservoirInstallation } from './water-reservoir-installation.dto';

export class PumpRoomInstallationDto extends InspectionCase {
  pumpRoomInstallationMain?: PumpRoomInstallationMain;
  waterReservoirInstallation?: WaterReservoirInstallation;
  pumps?: Pump[];
}

export class PumpRoomInstallation extends PumpRoomInstallationDto {
  constructor(
    data: PumpRoomInstallationDto = {
      title: 'תכנון חדר משאבות בהתאם לדרישות NFPA-20,22',
      isApplicable: true
    }
  ) {
    super(data);
    this.pumpRoomInstallationMain = new PumpRoomInstallationMain(
      data.pumpRoomInstallationMain
    );
    this.waterReservoirInstallation = new WaterReservoirInstallation(
      data.waterReservoirInstallation
    );

    this.pumps = data.pumps
      ? data.pumps.map((item) => new Pump(item))
      : [
          new Pump({ title: `משאבה מס' 1`, isPassed: true, isApplicable: true })
        ];
  }

  setInspectionStatus(): void {
    this.pumpRoomInstallationMain.setInspectionStatus();
    this.waterReservoirInstallation.setInspectionStatus();
    this.pumps.forEach((item) => item.setInspectionStatus());

    this.isPassed =
      this._isPassed() &&
      this.pumpRoomInstallationMain.isPassed &&
      this.waterReservoirInstallation.isPassed;
  }

  getNotes?(): CheckNotes[] {
    if (!this.isApplicable) {
      return [];
    }
    return [
      ...this.pumpRoomInstallationMain.getNotes(),
      ...this.waterReservoirInstallation.getNotes()
    ];
  }

  private _isPassed(): boolean {
    return !this.pumps.some((pump) => pump.isApplicable && !pump.isPassed);
  }

  setAsApplicable?(): void {
    this.isApplicable = true;
    this.pumpRoomInstallationMain.setAsApplicable();
    this.waterReservoirInstallation.setAsApplicable();
    this.pumps.forEach((pump) => pump?.setAsApplicable());
  }
}
